// Structure du cours "Tempalte"
import courseImage from './course-image.jpg';

export const courseStructure = {
  id: 'baseprogrammation',
  title: 'Les bases de la Programmation',
  image: courseImage,
  chapters: [
    {
      id: 'introduction',
      title: 'Introduction',
      path: '/cours/baseprogrammation'
    },
    {
      id: 'chapitre1',
      title: 'La programmation',
      path: '/cours/baseprogrammation/chapitre1'
    },
    {
      id: 'chapitre2',
      title: 'Première ligne de code',
      path: '/cours/baseprogrammation/chapitre2'
    },
    {
      id: 'chapitre3',
      title: 'Les variables',
      path: '/cours/baseprogrammation/chapitre3'
    },
    {
      id: 'chapitre4',
      title: 'Les conditions',
      path: '/cours/baseprogrammation/chapitre4'
    },
    {
      id: 'chapitre5',
      title: 'Les boucles',
      path: '/cours/baseprogrammation/chapitre5'
    },
    {
      id: 'chapitre6',
      title: 'Les listes et les tableaux',
      path: '/cours/baseprogrammation/chapitre6'
    },
    {
      id: 'chapitre7',
      title: 'Les structures',
      path: '/cours/baseprogrammation/chapitre7'
    },
    {
      id: 'chapitre8',
      title: 'Les fonctions',
      path: '/cours/baseprogrammation/chapitre8'
    },
    {
      id: 'chapitre9',
      title: 'Conclusion',
      path: '/cours/baseprogrammation/chapitre9'
    }
  ]
}; 